import React from "react";
import BlogEditor from "../../component/Blog/BlogEditor.tsx";

const BlogPage = () => {
  return (
    <div>
      <BlogEditor />
    </div>
  );
};

export default BlogPage;
